import { Injectable } from '@angular/core';
import {
  LogActionPayload,
  LogActionResponse,
  UserPublicProfile,
} from '@features/public-profile/utils/models/public-profile.model';
import { HttpHandler } from '@shared/utils/classes/http-handler';
import { HttpResponse } from '@shared/utils/models/http.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class PublicProfileService extends HttpHandler {
  getPublicProfile(slug: string): Observable<HttpResponse<[UserPublicProfile] | string>> {
    const url: string = environment.apiUrls.user.profile.getPublic;
    return this.post<HttpResponse<[UserPublicProfile] | string>>(url, { user_slug: slug });
  }

  logAction(payload: LogActionPayload): Observable<HttpResponse<LogActionResponse>> {
    const url: string = environment.apiUrls.user.logAction;
    return this.post<HttpResponse<LogActionResponse>>(url, payload);
  }
}
